<template>
  <v-card rounded>
    <v-row
      justify="space-around"
      ref="handle"
      class="mobile-handle"
      @click="onHandleClick">
      <v-icon v-if="position.y === bottom" large color="secondary">fa-angle-up</v-icon>
      <v-icon v-else large color="secondary">fa-angle-down</v-icon>
    </v-row>

    <slot />
  </v-card>
</template>

<script>
import interact from 'interactjs'

export default {
  name: 'MobileCard',
  props: {
    bounds: {
      required: true
    },
    target: {
      required: true
    },
    handleHeight: {
      default: 0
    }
  },
  computed: {
    safeAreaBottom () {
      const safeAreaStr = getComputedStyle(this.target).getPropertyValue('--sab')
      const safeAreaInt = parseInt(safeAreaStr.split('px')[0])

      return safeAreaInt
    }
  },
  data () {
    return {
      handle: null,
      position: { x: 0, y: 0 },
      bottom: 0
    }
  },
  mounted () {
    this.handle = this.$refs.handle

    // Disabled dragging for now due to issues with mobile safe areas

    // interact(this.handle).draggable({
    //   startAxis: 'y',
    //   lockAxis: 'y',
    //   modifiers: [
    //     interact.modifiers.restrictRect({
    //       restriction: this.bounds
    //     }),
    //     interact.modifiers.restrictRect({
    //       restriction: (x, y, element) => {
    //         const bounds = this.bounds.getBoundingClientRect()
    //         const offset = bounds.bottom - this.target.offsetHeight

    //         return {
    //           x: bounds.x,
    //           y: offset,
    //           width: bounds.width,
    //           height: this.target.offsetHeight - this.safeAreaBottom
    //         }
    //       }
    //     })
    //   ],
    //   listeners: {
    //     start: (event) => {},
    //     move: (event) => {
    //       this.position.x += event.dx
    //       this.position.y += event.dy

    //       this.target.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`
    //     }
    //   }
    // })

    this.$emit('update:handle-height', this.handle.offsetHeight)
  },
  beforeDestroy () {
    interact(this.handle).unset()
  },
  methods: {
    async onHandleClick () {
      this.bottom = this.target.offsetHeight - this.handle.offsetHeight - this.safeAreaBottom

      let event = ''
      if (this.position.y !== this.bottom) {
        this.position.y = this.bottom
        event = 'closed'
      } else {
        this.position.y = 0
        event = 'opened'
      }

      this.target.style.transition = 'transform 0.2s ease'
      this.target.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`

      await new Promise((resolve, reject) => {
        setTimeout(resolve, 200)
      })

      this.target.style.transition = ''

      this.$emit(event)
    },
    reset () {
      this.position.x = 0
      this.position.y = 0

      if (this.target) {
        this.target.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-handle {
  touch-action: none;
  user-select: none;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
}
</style>
